import { Button, Modal, Spinner } from "react-bootstrap"
import { INetworkIntegration } from "./network-settings"
import { MdDelete } from "react-icons/md"
import { useState } from "react"
import useFetch from "../../../_fetch"

export function NetworkTable (opts: {network: INetworkIntegration, fetchUserData: ()=>Promise<void>}) {
    const {fetchUserData,network} = opts
    
    const { doFetch } = useFetch()


    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [credentialsId, setCredentialsId] = useState<string>('')
    const [rm, setRm] = useState<boolean>(false)
    const [rmErr, setRmErr] = useState<boolean>(false)

    const handleDelete = (id:string) => {
        setShowDeleteModal(true)
        setRm(false)
        setRmErr(false)
        setCredentialsId(id)
    }

    const confirmDelete = async () => {
        setRm(true)
        try {
            const res = await doFetch('/remove-network-credentials', {credentialsId})
            if(res.status >= 400) throw `Err`

            await fetchUserData()

            setRm(false)
            setShowDeleteModal(false)
            setCredentialsId('')
        } catch(err) {
            setRm(false)
            setRmErr(true)
        }
    }

    const cancelDelete = () => {
        setCredentialsId('')
        setShowDeleteModal(false)
    }

    return (
        <>
            <div className="d-flex justify-content-between">
                <h4>Credentials</h4>
            </div>
            <div className="table table-responsive mt-2">
                <table className="table table-success table-striped table-sm mt-2">
                    <thead>
                        <tr>
                            {network.fields.map((field ,i)=>(
                                <th key={i}>{field.displayName || field.name}</th>
                            ))}
                            <th>Data ready</th>
                            <th>Remove</th>
                        </tr>
                    </thead>
                    <tbody>
                        {network.values.map((valueObj, i) => (
                            <tr key={i}>
                                {network.fields.map((field, j) => {
                                    const getVal = ()=> {
                                        const val = 'secret' in field ? '****' : valueObj[field.name]
                                        if(!Array.isArray(val)) return val

                                        return val.map((v,i) => {
                                            return (
                                                <div key={i}>
                                                    {Object.keys(v).map(k=>v[k]).join(' | ')}
                                                </div>
                                            )
                                        })
                                        
                                    }
                                    return (
                                        <td key={j}>
                                            {getVal()}
                                        </td>
                                    )
                                })}
                                <td>{valueObj._wasInitialized ? 'Yes' : 'No'}</td>
                                <td>
                                    <div 
                                    className={"text-danger " + (valueObj._wasInitialized ? '' : 'd-none')} 
                                    style={{cursor:'pointer'}}
                                    onClick={() => handleDelete((valueObj as any)._id)}
                                    >
                                        <MdDelete />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Modal show={showDeleteModal} onHide={cancelDelete}>
                <Modal.Header>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                Are you sure you want to delete this item? All data belonging to these credentials will be removed from this dashboard
                {rmErr ? <div className="text-danger">Something went wrong. Please try again.</div> : ''}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={cancelDelete} disabled={rm}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={confirmDelete} disabled={rm}>
                        Delete {rm ? <Spinner animation="border" size="sm" /> : ''}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
